export default __webpack_public_path__ + "static/img-worries_people1_pc-deb5b783d5eb7109601e561dca2dcf67.svg";